import React from 'react';

import Footer from './../Footer';
import CategoryHeader from './../CategoryHeader';
import Products from './../product/';
import { motion } from 'framer-motion';

export default function App() {
  return (
    <motion.div className="app" exit={{ opacity: 0 }}>
      <CategoryHeader />
      <Products />
      <Footer />
    </motion.div>
  );
}
